// extracted by extract-css-chunks-webpack-plugin
module.exports = {"appFrame":"appFrame__appFrame--2GoLf","mainContentBelowHeader":"appFrame__mainContentBelowHeader--1HZ9O","main":"appFrame__main--30CB2"};